export const setFontSize = () => {
  const baseSize = 16 //默认字体大小
  const baseWidth = 1920
  const clientWidth = document.documentElement.getBoundingClientRect().width //窗口宽度

  // 实际缩放大小改变字体大小
  // const scale = clientWidth / baseWidth
  // //如果有缩放就重新设置字体
  // if (100 / detectZoom() < 1) {
  //   // 实际缩放大小改变字体大小
  //   document.documentElement.style.fontSize = baseSize * scale + 'px'
  // }
  //根据宽度设置字体大小
  const fontSize = clientWidth / 100 //当前宽度分成100份后的字体大小
  //如果有缩放就重新设置字体
  if (100 / detectZoom() < 1) {
    // 根据宽度设置字体大小
    document.documentElement.style.fontSize = fontSize + 'px'
  }
}
// interface ifScreen extends Screen {
//   deviceXDPI?: number,
//   logicalXDPI?: number
// }
const detectZoom = () => {
  let ratio = 0
  const screen = window.screen
  const ua = navigator.userAgent.toLowerCase()
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (~ua.indexOf('msie')) {
    if ('deviceXDPI' in screen && 'logicalXDPI' in screen) {
      ratio = screen.deviceXDPI / screen.logicalXDPI
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    ratio = window.outerWidth / window.innerWidth;
  }
  if (ratio) {
    ratio = Math.round(ratio * 100);
  }
  return ratio;
}